export const AdminPageTitle = ({ title }) => {
  return <h2 className="text-dark text-center mb-4">{title}</h2>;
};
